<template>
	<div class="relative bg-base-100">
		<div class="tabs tabs-lifted relative z-10 w-fit">
			<a class="tab" :class="activeTab === 'my-library' ? 'tab-active' : 'text-base-content-light hover:text-base-content'" @click="handleClick('my-library')">
				{{ $t('My library') }}
			</a>
			<!-- <a class="tab" :class="activeTab === 'followed-authors' ? 'tab-active' : 'text-base-content-light hover:text-base-content'" @click="">
				{{ $t('Followed authors') }}
			</a> -->
			<a class="tab" :class="activeTab === 'discover' ? 'tab-active' : 'text-base-content-light hover:text-base-content'" @click="handleClick('discover')">
				{{ $t('Discover') }}
			</a>
		</div>
		<div class="border-base-300 border-b absolute bottom-0 left-0 right-0" />
	</div>
</template>


<style scoped>
/* Override DaisyUI tab styles */
.tabs > a.tab {
	@apply h-10 [--tab-padding:1.5rem];
}
.tabs > a.tab-active {
	@apply  [--tab-bg:white];
}
</style>


<script lang="ts">
export default {
	name: 'LessonPlanLibraryTabs',

	emits: ['change'],

	props: {
		activeTab: {
			type: String,
			required: true,
			validator(value: string) {
				return ['my-library', 'followed-authors', 'discover'].includes(value);
			}
		},
	},

	methods: {
		i18nLabel(tabName: string): string {
			switch (tabName) {
				case 'my-library':
					return this.$t('My library');
				case 'followed-authors':
					return this.$t('Followed authors');
				case 'discover':
					return this.$t('Discover');
				default:
					return tabName;
			}
		},

		handleClick(tabName: string) {
			if(this.activeTab === tabName) {
				return; // already on this tab, do nothing
			}
			this.$emit('change', tabName);
		},
	},
}
</script>
